import { useState } from "react";
import { faqs } from "@/mocks/homeNews";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          {/* 左侧：追更说明 */}
          <div className="lg:col-span-5">
            <p className="inline-flex items-center gap-2 mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
              <span className="h-px w-6 bg-primary-500 inline-block" />
              追更前，先看这里
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
              关于每日黑料，<br className="hidden sm:block" />
              你想知道的全在这
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md">
              从内容可信度到最快追更方法，我们把最常被问到的问题一次说清楚。想抢在别人之前吃瓜，先把规则摸透。
            </p>
            <div className="mt-6 flex flex-col gap-3">
              <a
                href="#dujia"
                className="inline-flex items-center gap-3 rounded-lg border border-background-200 bg-background-100/60 p-4 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="flex items-center justify-center w-10 h-10 rounded-md bg-primary-600 text-background-50">
                  <i className="ri-thunderstorms-line w-5 h-5 flex items-center justify-center" />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-950">第一手独家曝光</span>
                  <span className="block text-xs text-foreground-600 mt-0.5">去翻今天放出的最新猛料</span>
                </span>
              </a>
              <a
                href="#rebang"
                className="inline-flex items-center gap-3 rounded-lg border border-background-200 bg-background-100/60 p-4 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="flex items-center justify-center w-10 h-10 rounded-md bg-accent-500 text-background-50">
                  <i className="ri-fire-fill w-5 h-5 flex items-center justify-center" />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-950">看看今天谁在热榜</span>
                  <span className="block text-xs text-foreground-600 mt-0.5">全网吃瓜焦点一键掌握</span>
                </span>
              </a>
            </div>
          </div>

          {/* 右侧：FAQ 手风琴 */}
          <div className="lg:col-span-7">
            <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={i}>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/60 transition-colors"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex items-center justify-center w-6 h-6 shrink-0 rounded-full text-[11px] font-bold ${
                            isOpen ? "bg-primary-600 text-background-50" : "bg-secondary-100 text-foreground-700"
                          }`}
                        >
                          Q{i + 1}
                        </span>
                        <span className="text-sm md:text-[15px] font-semibold text-foreground-950 leading-snug">
                          {f.q}
                        </span>
                      </span>
                      <i
                        className={`ri-add-line w-5 h-5 flex items-center justify-center shrink-0 text-foreground-500 transition-transform duration-300 ${
                          isOpen ? "rotate-45 text-primary-600" : ""
                        }`}
                      />
                    </button>
                    <div
                      className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                        isOpen ? "max-h-96" : "max-h-0"
                      }`}
                    >
                      <p className="px-5 pb-5 pl-[3.75rem] text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}